export default {
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Delete failed',
  updateSuccess: 'Updated successfully',
  updateFailed: 'Update failed',
  networkError: 'Network error, please try again later',
  serverError: 'Server error, please try again later',
  timeout: 'Request timeout, please try again later',
  actionSuccess: 'Operation successful',
  actionFailed: 'Operation failed',
  addSuccess: 'Added successfully',
  editSuccess: 'Edited successfully',
  deleteSuccess: 'Deleted successfully',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Failed to save',
  confirmDelete: 'Are you sure you want to delete? This action cannot be undone',
  product: {
    addSuccess: 'Product added successfully',
    editSuccess: 'Product edited successfully',
    deleteSuccess: 'Product deleted successfully',
  },
  batch: {
    saveSuccess: 'Saved successfully',
    saveFailed: 'Failed to save',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Failed to delete',
  },
  category: {
    actionSuccess: 'Operation successful',
    actionFailed: 'Operation failed',
    deleteSuccess: 'Deleted successfully',
  },
  attr: {
    actionSuccess: 'Operation successful',
    actionFailed: 'Operation failed',
    deleteSuccess: 'Deleted successfully',
  },
  gift: {
    actionSuccess: 'Operation successful',
    actionFailed: 'Operation failed',
    deleteSuccess: 'Deleted successfully',
  },
  giftCategory: {
    actionSuccess: 'Operation successful',
    actionFailed: 'Operation failed',
    deleteSuccess: 'Deleted successfully',
  },
  factory: {
    actionSuccess: 'Operation successful',
    actionFailed: 'Operation failed',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Failed to delete',
  },
};
